import { render } from "./MoneyballStickChart.vue?vue&type=template&id=f5a6a04a"
import script from "./MoneyballStickChart.vue?vue&type=script&lang=js"
export * from "./MoneyballStickChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__